<template>
	<section :class="['tabList', 'px-6', 'md:px-16',  'pb-36', slug]">
		<div
			v-for="item in items"
			:key="item.id"
			class="tab"
			@click="openModal(item)"
		>
			<div class="heading">
				<h2>{{ item.heading }}</h2>
				<p v-if="item.rsf" class="sqft">
					{{ item.rsf.toLocaleString() }} RSF
				</p>
			</div>

			<div class="indicator">
				<svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" fill="none">
					<path fill="#29261E" d="M0 8V6h12L8 2l1-2 7 7-7 7-1-2 4-4H0z" />
				</svg>
			</div>
		</div>
		
		<div class="modals">
			<div
				v-for="item in items"
				:key="item.id"
				:class="['modal', { active: activeModal === item.id || modal === item.id } ]"
			>
				<div v-if="item.type === 'floor'" class="modal-body">
					<div class="close" @click="dismissModal">
						<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none">
							<path fill="#58554D" fill-rule="evenodd" d="M16 .5L17.5 2l-7 7 7 7-1.5 1.5-7-7-7 7L.5 16l7-7-7-7L2 .5l7 7 7-7z" clip-rule="evenodd" />
						</svg>
					</div>

					<div class="intro">
						<h3 class="h2">
							{{ item.heading }}
						</h3>

						<p v-if="item.rsf" class="sqft">
							{{ item.rsf.toLocaleString() }} RSF
						</p>
					</div>

					<div
						v-if="item.images.length > 0"
						class="building-image"
					>
						<img v-for="image in item.images" :key="image.id" :src="image.url" :alt="image.title" loading="lazy">
					</div>

					<div class="copy" v-html="item.copy" />

					<div class="ctas">
						<a
							v-if="item.cta.length"
							:href="`/${item.cta[0].slug}`"
							class="cta"
						>
							{{ item.ctaCopy }}
						</a>

						<a
							v-for="floorplan in item.floorplan"
							:key="floorplan.id"
							:href="floorplan.url"
							class="download"
							target="_blank"
							rel="noopener"
						>
							Download Floorplan
						</a>

						<a
							v-for="stackingPlan in item.stackingPlan"
							:key="stackingPlan.id"
							:href="stackingPlan.url"
							class="download"
							target="_blank"
							rel="noopener"
						>
							Download Stacking Plan
						</a>
					</div>
				</div>

				<div v-else-if="item.type === 'directions'" class="modal-body">
					<div class="close">
						<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" @click="activeModal = ''; activeSubTab = 'ingress'">
							<path fill="#58554D" fill-rule="evenodd" d="M16 .5L17.5 2l-7 7 7 7-1.5 1.5-7-7-7 7L.5 16l7-7-7-7L2 .5l7 7 7-7z" clip-rule="evenodd" />
						</svg>
					</div>

					<div v-if="item.ingress && item.egress" class="tabs">
						<ul class="row">
							<li
								:class="[ 'col', 'ingress', { active: activeSubTab === 'ingress' } ]"
								@click="activeSubTab = 'ingress'"
							>
								Ingress
							</li>
							<li
								:class="[ 'col', 'egress', { active: activeSubTab === 'egress' } ]"
								@click="activeSubTab = 'egress'"
							>
								Egress
							</li>
						</ul>
					</div>

					<div class="modal-content">
						<div class="heading">
							<h2>{{ item.heading }}</h2>
						</div>

						<div class="copy">
							<div :class="[ 'ingress', { active: activeSubTab === 'ingress' } ]">
								<div v-html="item.ingress" class="mb-4" />
								<img
									v-if="item.ingressMap.length > 0"
									:src="item.ingressMap[0].url"
									:alt="item.ingressMap[0].title"
								>
							</div>
							<div :class="[ 'egress', { active: activeSubTab === 'egress' } ]">
								<div v-html="item.egress" class="mb-4" />
								<img
									v-if="item.egressMap.length > 0"
									:src="item.egressMap[0].url"
									:alt="item.egressMap[0].title"
								>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	props: {
		modal: {
			type: String,
			required: false,
			default: "",
		},
	},
	data() {
		return {
			activeModal: "",
      activeSubTab: "ingress",
			items: [],
			slug:  window.location.pathname.split('/').pop(),
		};
	},
	mounted () {
		this.fetchResults()
	},
	methods: {
		async fetchResults() {
      const query = `
       query {
				page: entry(slug: "${this.slug}") {
					id
					title
					slug
					... on pages_tabList_Entry {
						id
						slug
						image {
							url
							title
						}
						title
						tabList {
							... on tabList_BlockType {
								id
								type: __typename
								items {
									... on items_directions_BlockType {
										id
										heading
										ingress
										ingressMap {
											id
											url
											title
										}
										egress
										egressMap {
											id
											url
											title
										}
										type: typeHandle,
										
									}
									... on items_floor_BlockType {
										id
										type: typeHandle
										heading
										rsf
										images {
											id
											url
											title
										}
										copy
										cta {
											id
											slug
										}
										ctaCopy
										floorplan {
											title
											url
										}
										stackingPlan {
											title
											url
										}
									}
								}
							}
						}
					}
				}
			}
      `;
      let response = await fetch('/api', {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ query })
      })

      if (response.ok) {
				let json = await response.json();
        this.items = json.data.page.tabList[0].items
      }

      return []
    },
		blockType(block) {
			return block.type.split("_")[2];
		},
		openModal(item) {
			this.activeModal = item.id;
			this.$emit("modalOpened", this.activeModal);
		},
		dismissModal() {
			this.activeModal = "";
			this.$emit("modalClosed", this.activeModal);
		},
	},
	watch: {
		modal(newValue, oldValue) {
			if (newValue !== "") {
				this.activeModal = newValue;
			}
		},
	},
};
</script>

<style lang="scss">
.tabList {
	&.floor {
		.tab {
			margin-bottom: 1.5rem;
			transition: all 0.3s ease-in-out;

			.sqft {
				color: theme('colors.gray.600');
				font-size: 0.875;
				line-height: 1.375;
				letter-spacing: 0.01em;
			}
		}

		.building-image {
			margin-bottom: 2rem;
		}

		.modals .modal {
			height: calc(100% - 8rem);
			min-height: initial;
			overflow-y: scroll;
			padding-bottom: 8rem;

			li {
				border-bottom: 1px solid theme('colors.gray.500');
				color: theme('colors.gray.800');
				font-size: 1.125rem;
				line-height: 1.5rem;
				margin-bottom: 2rem;
				padding-bottom: 0.4375rem;
			}
		}
	}

	.tab {
		align-items: center;
		border-bottom: 1px solid theme('colors.gray.500');
		cursor: pointer;
		display: flex;
		justify-content: space-between;
		margin-bottom: 2rem;
		padding: 8px;

		&:last-child {
			margin-bottom: 0;
		}

		&:hover {
			background-color: theme('colors.gray.100');
		}

		h2 {
			color: theme('colors.gray.800');
			font-size: 18px;
			font-weight: normal;
			line-height: 24px;
			margin-bottom: 0;
		}

		svg {
			transition: all 0.3s ease-in-out;
		}
	}

	&.directions {
		position: relative;

		.modal {
			padding: 2.5rem 0;

			&.active {
				height: 100%;
			}

			.tabs {
				padding: 0 2.5rem;
			}

			.tabs {
				align-items: center;
				border-bottom: 1px solid theme('colors.gray.500');
				display: flex;
				justify-content: center;
				margin-bottom: 1.9375rem;
				padding-bottom: 1rem;

				.row {
					width: 100%;
				}

				.col {
					align-items: center;
					color: theme('colors.gray.600');
					cursor: pointer;
					display: flex;
					justify-content: center;
					letter-spacing: 0.01em;
					line-height: 2.5rem;
					text-align: center;
					transition: color 0.3s ease-out;
					will-change: color;

					&:first-child {
						border-right: 1px solid theme('colors.gray.500');
					}

					&.active {
						// font-weight: $font-semibold;

						&:after {
							background-color: theme('colors.white');
							bottom: -1rem;
							content: "";
							display: block;
							height: 3px;
							left: 0;
							margin: 1rem auto 0;
							position: absolute;
							right: 0;
							transition: all 0.3s ease-in-out;
							width: 55%;
						}
					}

					&:hover {
						color: theme('colors.gray.800');
						transition: color 0.3s ease-out;
					}
				}
			}

			.modal-body {
				.close {
					margin-bottom: 2.5rem;
				}
			}

			.modal-content {
				overflow-y: scroll;
				overflow-x: hidden;
				height: 30rem;
				.copy {
					position: relative;

					.ingress,
					.egress {
						opacity: 0;
						position: absolute;
						top: 0;
						left: 0;
						transform: translateX(100%);
						transition: all 0.2s ease-in-out;

						&.active {
							opacity: 1;
							transform: translateX(0);
						}

						p {
							margin-bottom: 2.5rem;
						}

						ul {
							margin-left: -0.5rem;
						}

						li {
							background-image: url("https://cdn2.assets-servd.host/willing-hornbill/production/images/icons/map-direction.svg");
							background-position: 0.5rem 0.5rem;
							background-repeat: no-repeat;
							color: theme('colors.gray.600');
							display: flex;
							font-size: 1rem;
							letter-spacing: 0.02em;
							line-height: 1.5rem;
							overflow: visible;
							padding-bottom: 1.5rem;
							padding-left: 1.875rem;

							&:last-child {
								background-image: url("https://cdn2.assets-servd.host/willing-hornbill/production/images/icons/map-pin.svg");
								background-position: 0 0.3rem;
							}
						}
					}
				}
			}
		}
	}

	.modals {
		.modal {
			background-color: theme('colors.blue.100');
			height: 100%;
			min-height: calc(100vh - 8rem);
			padding: 2.5rem;
			position: fixed;
			right: 0;
			top: 8rem;
			transform: translateX(100%);
			transition: all 0.3s ease-out;
			width: calc(35% - 2rem);
			z-index: 600;

			@media (max-width: 1068px) {
				min-height: auto;
				top: 4rem;
				width: 100%;
			}

			&.active {
				transform: translateX(0);
				transition: all 0.3s ease-out;

				@media (max-width: 1068px) {
					transform: translate(0, 0);
				}
			}

			.close {
				cursor: pointer;
				margin-bottom: 4.6875rem;
			}

			.intro {
				h3 {
					margin-bottom: 0;
				}

				.sqft {
					color: theme('colors.gray.700');
					font-size: 1rem;
					font-weight: normal;
					letter-spacing: 0.02em;
					line-height: 1.25rem;
					margin-bottom: 1.5rem;
				}
			}

			.image {
				background-color: theme('colors.red.200');
				height: 14.5rem;
				margin-bottom: 3rem;
			}

			.copy {
				margin-bottom: 2.5rem;
			}

			.ctas {
				align-items: center;
				display: flex;
				flex-flow: column;
				justify-content: center;

				.cta {
					background-color: theme('colors.gray.800');
					color: theme('colors.gray.300');
					font-size: 18px;
					line-height: 24px;
					margin-bottom: 1rem;
					padding: 16px;
					text-align: center;
					text-decoration: none;
					transition: all 0.3s ease-in-out;
					width: 100%;

					&:hover {
						background-color: theme('colors.gray.800');
						color: theme('colors.white');
					}
				}

				.download {
					border: 2px solid theme('colors.gray.600');
					color: theme('colors.gray.600');
					font-size: 18px;
					line-height: 24px;
					margin-bottom: 1rem;
					padding: 16px;
					text-align: center;
					text-decoration: none;
					transition: all 0.3s ease-out;
					width: 100%;

					&:last-child {
						margin-bottom: 0;
					}

					&:hover {
						border-color: theme('colors.gray.800');
						color: theme('colors.gray.800');
						transition: all 0.3s ease-out;
					}
				}
			}
		}
	}
}
</style>
